"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupRoleBranchObserverImpl = void 0;
class GroupRoleBranchObserverImpl {
    subject;
    data = [];
    constructor(subject) {
        this.subject = subject;
    }
    getState() {
        return this.data;
    }
    getEventListener() {
        return this.subject.getEventListener();
    }
    update() {
        this.data = this.subject.getState();
    }
}
exports.GroupRoleBranchObserverImpl = GroupRoleBranchObserverImpl;
